import { render } from "./PromoteDemote.vue?vue&type=template&id=b6f1923c&scoped=true"
import script from "./PromoteDemote.vue?vue&type=script&lang=js"
export * from "./PromoteDemote.vue?vue&type=script&lang=js"

import "./PromoteDemote.vue?vue&type=style&index=0&id=b6f1923c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f1923c"]])

export default __exports__